import { useCallback, useEffect, useState } from 'react';

const useIsFocused = (
  containerRef,
  selector,
): [boolean, React.Dispatch<React.SetStateAction<boolean>>] => {
  const [isFocused, setIsFocused] = useState(false);

  const handleDomClick = useCallback(
    (event: MouseEvent) => {
      const root = containerRef.current;
      const menu = root?.querySelector(selector);

      if (menu) {
        if (!menu.contains(event.target)) {
          setIsFocused(false);
        }
      } else {
        if (root?.contains(event.target)) {
          setIsFocused(true);
        }
      }
    },
    [containerRef, selector],
  );

  useEffect(() => {
    document.addEventListener('click', handleDomClick, true);

    return () => {
      document.removeEventListener('click', handleDomClick);
    };
  }, [handleDomClick]);

  return [isFocused, setIsFocused];
};

export default useIsFocused;
